import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import Reducers from './reducers';
import storage from './storage';

export const SESSION_STATE_KEY = 'app.context.store.ef37bc9f1';
/* Redux thunk middleware */
const middleware = [thunk];

export const initializeStore = async () => {
  // Load initial state from storage (async)
  let initialState = {};
  try {
    console.log('Loading initial state from storage...');
    const storedState = await storage.getItem(SESSION_STATE_KEY);

    if (storedState) {
      // Validate that storedState is an object
      if (typeof storedState === 'object' && storedState !== null) {
        initialState = storedState;
        console.log('✅ Loaded state from storage');
      } else {
        console.warn('⚠️ Stored state is not an object, using empty state');
      }
    } else {
      console.log('ℹ️ No stored state found, using empty state');
    }
  } catch (error) {
    console.error('❌ Failed to load initial state from storage:', error);
    console.log('ℹ️ Using empty initial state');
  }

  const store = createStore(
    Reducers,
    initialState,
    getMiddleWare()
  );

  // Subscribe to store changes and persist to storage (async, non-blocking)
  store.subscribe(() => {
    // Use async storage but don't block the subscribe callback
    storage.setItem(SESSION_STATE_KEY, store.getState()).catch(error => {
      console.error('Failed to persist state to storage:', error);
    });
  });

  return store;

};

function getMiddleWare() {
  if ((!process.env.NODE_ENV || process.env.NODE_ENV === 'development') /*&& !isMobile()*/) {
    return compose(
      applyMiddleware(
        ...middleware));
  } else {
    return applyMiddleware(...middleware);
  }
}